module.exports = __webpack_public_path__ + "static/assets/c4223869e4bb0a1a956fba19c968cfa0.png";